<template>
  <div>
    <table
      style="border: solid 1px #333; border-collapse: collapse"
      border="1"
      class="table-print"
      v-html="printData"
    ></table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["printData"]),
  },
  mounted() {
    setTimeout(() => {
      window.print();
      this.$router.go(-1);
    }, 100);
  },
};
</script>

<style lang="scss">
.table-print {
  width: 100%;
  td {
    padding: 10px !important;
  }

  tr {
    border-bottom: solid 1px #333;
  }
}
</style>